export const version = {
  major: 1,
  minor: 7
};
